import React from "react";
import { Link } from "react-router-dom";

const FeedTop = () => {
  return (
    <div className="flex flex-row justify-center items-center space-x-4 md:w-96 bg-white md:mx-2 md:py-2">
      <Link
        to="/leaderboard"
        className="flex w-1/3 flex-col items-center justify-center px-1"
      >
        <div className="rounded-full bg-primaryColor w-[96px] h-[96px] flex justify-center items-center">
          <span className="text-white font-bold  text-[12px]">Leaderboard</span>
        </div>
      </Link>
      <div className="flex w-1/3 flex-col items-center justify-center px-1">
        <Link to="/trading-floor">
          <div className="rounded-full bg-primaryColor w-[96px] h-[96px] flex justify-center items-center">
            <span className="text-white text-center  text-[12px] font-bold">
              Trading Floor
            </span>
          </div>
        </Link>
      </div>

      {/* <div className="flex w-1/3 flex-col items-center justify-center px-1">
        <Link to="/market-sentiment">
          <div className="rounded-full bg-primaryColor w-[76px] h-[76px] flex justify-center items-center">
            <span className="text-white text-center font-bold">Market Sentiment</span>
          </div>
        </Link>
      </div> */}

      <div className="flex w-1/3 flex-col items-center justify-center px-1">
        <Link to="/contest">
          <div className="rounded-full bg-primaryColor w-[96px] h-[96px] flex justify-center items-center">
            <span className="text-white text-center font-bold text-[12px]">League <br/>Play</span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default FeedTop;
